import {
  parseSectionArray, 
  parseLayoutArray,
  parsePagesArray,
  createUsingSchema,
  CURRENT_SECTION_VERSION,
  CURRENT_STYLE_VERSION, 
  CURRENT_PAGE_VERSION,
} from '../index'
import { LAYOUT_SCHEMA } from '../layout/schema'
import { PAGE_SCHEMA } from '../pages/schema'
import { generateId } from '../../helpers/generateId'
import { changeNullForStringValue } from '../../helpers/recursive'

export const parseInfos = (_infos) => {
  let infos = JSON.parse(JSON.stringify(_infos))

  const {isDifferentPageVersion, isDifferentSectionVersion, isDifferentStyleVersion} = parseVersions(infos)
  parseLayouts(infos, isDifferentStyleVersion)
  parsePages(infos, isDifferentPageVersion)
  parseSections(infos, isDifferentSectionVersion)

  // console.log('INFOS -----> :', infos)

  return infos
}

const parseVersions = (infos) => {
  const isDifferentStyleVersion = !infos._internal_styleVersion || infos._internal_styleVersion !== CURRENT_STYLE_VERSION
  const isDifferentSectionVersion = !infos._internal_sectionVersion || infos._internal_sectionVersion !== CURRENT_SECTION_VERSION
  const isDifferentPageVersion = !infos._internal_pageVersion || infos._internal_pageVersion !== CURRENT_PAGE_VERSION

  if (!infos._internal_styleVersion) infos = {...infos, _internal_styleVersion: CURRENT_STYLE_VERSION }
  if (!infos._internal_sectionVersion) infos = {...infos, _internal_sectionVersion: CURRENT_SECTION_VERSION}
  if (!infos._internal_pageVersion) infos = {...infos, _internal_pageVersion: CURRENT_PAGE_VERSION}

  return {isDifferentStyleVersion, isDifferentSectionVersion, isDifferentPageVersion}
}

const parseLayouts = (infos, isDifferentStyleVersion) => {
  // Executa apenas quando ainda está utilizando o JSON de config da v1 que ainda não possuia array de layout
  const haveArrayOfLayouts = infos.layout && Array.isArray(infos.layout)

  if (!haveArrayOfLayouts) {
    const defaultStyle = createUsingSchema(LAYOUT_SCHEMA({id: 'default-style', button: {'background-color': '#3563F1'}}))

    const currentStyle = createUsingSchema(LAYOUT_SCHEMA({
      id: generateId(),
      label: "Estilo Padrão",
      title: {...infos.layout.title},
      subtitle: {...infos.layout.subtitle},
      text: {...infos.layout.text},
      button: {...infos.layout.button}
    }))

    infos.layout = [defaultStyle, currentStyle]
    console.log('Estrutura ** inicial de layout ** utilizando múltiplos estilos foi criada...')
  }

  const keepNullValueForKeys = ['color', 'font', 'font-size', 'font-style', 'weight']

  if (isDifferentStyleVersion) {
    infos.layout = changeNullForStringValue(infos.layout, keepNullValueForKeys)
    infos.layout = parseLayoutArray(infos.layout)

    console.log('Estrutura dos objetos dos ** estilos ** foi atualizada para nova versão...', CURRENT_STYLE_VERSION)
    Object.assign(infos, {_internal_styleVersion: CURRENT_STYLE_VERSION})
  }  
}

const parsePages = (infos, isDifferentPageVersion) => {
  // Executa apenas quando ainda não possui a array de pages definida
  const haveArrayOfPages = infos.pages && Array.isArray(infos.pages)
  
  if (!haveArrayOfPages) {
    const defaultPage = createUsingSchema(PAGE_SCHEMA())
    infos.pages = [defaultPage]
    infos.sections.forEach(section => { section.pageId = defaultPage.id })
    console.log('Estrutura ** inicial de páginas ** foi criado...')
  }

  if (isDifferentPageVersion) {
    infos.pages = changeNullForStringValue(infos.pages)
    infos.pages = parsePagesArray(infos.pages)

    console.log('Estrutura das ** páginas ** foi atualizado para nova versão...', CURRENT_PAGE_VERSION)
    Object.assign(infos, {_internal_pageVersion: CURRENT_PAGE_VERSION})
  }  
}

const parseSections = (infos, isDifferentSectionVersion) => {
  const keepNullValueForKeys = ['color', 'font', 'font-size', 'font-style', 'weight']

  // Executa toda vez que o schema das seções mudar ou quando seção nao tiver layout base
  const allSectionHaveLayoutBase = infos.sections.every(section => section.hasOwnProperty('idLayout'))
  if (!allSectionHaveLayoutBase || isDifferentSectionVersion) {
    infos.sections = changeNullForStringValue(infos.sections, keepNullValueForKeys)
    infos.sections = parseSectionArray(infos.sections)
    
    console.log('Estrutura dos objetos das ** seções ** foi atualizado para nova versão...', CURRENT_SECTION_VERSION)
    Object.assign(infos, {_internal_sectionVersion: CURRENT_SECTION_VERSION})
  }

  infos.layout = changeNullForStringValue(infos.layout)
}